import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { useLang } from "@/context/LanguageContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Share2, Copy, Check } from "lucide-react";
import { toast } from "sonner";

export const ShareDialog = ({ trigger }) => {
  const { t, lang } = useLang();
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.origin : "";

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success(t("linkCopied"));
      setTimeout(() => setCopied(false), 1500);
    } catch (_) {
      toast.error("Copy failed");
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <Button variant="outline" className="border-[#993D22] text-[#993D22] rounded-full px-3 sm:px-4" data-testid="share-village-btn" aria-label={t("shareVillage")}>
            <Share2 className="w-4 h-4 sm:mr-2" /> <span className="hidden sm:inline">{t("shareVillage")}</span>
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="bg-[#FAF7F2] max-w-md">
        <DialogHeader>
          <DialogTitle className="font-serif-heritage text-2xl text-[#261911]">{t("shareVillage")}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-[#6E5B4F] mb-4">{t("shareDesc")}</p>

        <div className="flex justify-center mb-4" data-testid="share-qr">
          <div className="p-4 rounded-xl bg-white border-2 border-[#993D22]">
            <QRCodeSVG value={url} size={200} fgColor="#261911" bgColor="#FFFFFF" level="M" />
          </div>
        </div>

        <div className="flex items-center gap-2 bg-white rounded-full border border-[#E3D5CA] p-1.5">
          <code className="flex-1 truncate text-xs sm:text-sm text-[#3A2312] px-2" data-testid="share-url">
            {url}
          </code>
          <Button
            type="button"
            size="sm"
            onClick={copy}
            className="btn-terra !py-1.5 !px-3"
            data-testid="copy-link-btn"
          >
            {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
          </Button>
        </div>

        <p className="text-xs italic text-[#6E5B4F] mt-4 text-center">
          {lang === "fr"
            ? "Toute personne qui ouvre ce lien peut parcourir l'arbre. Pour contribuer, elle doit créer un compte ou proposer une correction."
            : "Anyone opening this link can browse the tree. To contribute, they must create an account or submit a correction."}
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default ShareDialog;
